import type { TaskPriority } from '../../../shared/lib/datetime';

export interface TaskEntity {
  id: string;
  user_id: string;
  title: string;
  description: string;
  priority: TaskPriority;
  due_date: string | null;
  due_time: string | null;
  duration_minutes: number | null;
  all_day: boolean;
  /** Идея (не задача в списках Сегодня/Завтра/Календарь). */
  is_idea: boolean;
  completed: boolean;
  completed_at: string | null;
  archived_at: string | null;
  recurrence_rule: string | null;
  /** Проект задачи. null — «Без проекта». */
  project_id: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export interface TagEntity {
  id: string;
  user_id: string;
  name: string;
  color: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export interface ProjectEntity {
  id: string;
  user_id: string;
  name: string;
  color: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export interface ChecklistItemEntity {
  id: string;
  task_id: string;
  user_id: string;
  text: string;
  done: boolean;
  sort_order: number;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export interface TaskTagEntity {
  id: string;
  task_id: string;
  tag_id: string;
  user_id: string;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export interface CompletionEntity {
  id: string;
  task_id: string;
  occurrence_date: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  server_revision: number | null;
  dirty: boolean;
}

export function taskTagId(taskId: string, tagId: string): string {
  return `${taskId}:${tagId}`;
}

export function completionId(taskId: string, occurrenceDate: string): string {
  return `${taskId}:${occurrenceDate}`;
}
